import { render, staticRenderFns } from "./showcase.vue?vue&type=template&id=2e99888e&scoped=true"
import script from "./showcase.ts?vue&type=script&lang=ts&external"
export * from "./showcase.ts?vue&type=script&lang=ts&external"
import style0 from "./showcase.scss?vue&type=style&index=0&id=2e99888e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99888e",
  null
  
)

export default component.exports